import { Component, Inject, OnInit } from '@angular/core';
import { NoticeController } from '@shared/src/controllers/notice/notice.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { NoticeAcknowledgeDto, NoticeViewDto, NoticeViewQuestionDto } from '@shared/src/dtos/notice/NoticeViewDto';

/***
 * Avisos pendents. Es mostra per sobre de tot i no desapareix fins que l'usuari
 * hi actua responent les preguntes obligatòries.
 */
@Component({
    selector: 'shared-notice-popover-component',
    templateUrl: './shared.notice.popover.component.html',
    styleUrls: ['./shared.notice.popover.component.scss'],
})
export class SharedNoticePopoverComponent implements OnInit {

    public notices: NoticeViewDto[] = [];
    public current: NoticeViewDto = null;

    constructor(
        @Inject('SecurityController') protected securityController: SecurityController,
        protected noticeController: NoticeController) { }

    ngOnInit(): void {
        if (this.securityController.loginStatusChanged$)
            this.securityController.loginStatusChanged$.subscribe(() => this.load());
        this.load();
    }

    public load(): void {
        this.securityController.isLogged().subscribe(logged => {
            if (!logged) {
                this.notices = [];
                this.current = null;
                return;
            }
            this.noticeController.getPending().subscribe(data => {
                this.notices = data != null ? data : [];
                this.showFirst();
            });
        });
    }

    public setAnswer(question: NoticeViewQuestionDto, answer: boolean): void {
        question.answer = answer;
    }

    public canConfirm(): boolean {
        if (this.current == null)
            return false;
        if (this.current.questions == null)
            return true;
        return this.current.questions.every(question => !question.isRequired || question.answer != null);
    }

    public confirm(): void {
        if (!this.canConfirm())
            return;

        const notice = this.current;
        const value = new NoticeAcknowledgeDto();
        if (notice.questions != null)
            notice.questions.filter(question => question.answer != null).forEach(question => value.answers.push({
                noticeQuestionId: question.noticeQuestionId,
                answer: question.answer
            }));

        this.noticeController.acknowledge(notice.noticeId, value).subscribe(done => {
            if (!done)
                return;
            this.notices = this.notices.filter(x => x.noticeId !== notice.noticeId);
            this.showFirst();
        });
    }

    protected showFirst(): void {
        this.current = this.notices.length > 0 ? this.notices[0] : null;
        if (this.current != null)
            this.noticeController.markSeen(this.current.noticeId).subscribe();
    }
}
